import React from 'react';
import Tetris from './Tetris'

const App = () => {
    return (
            <Tetris />
    );
}

export default App;